import { m } from '@/lib/paraglide/messages'

const MS_PER_DAY = 86_400_000
const VN_DAY = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Ho_Chi_Minh',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
})

/** Calendar day (YYYY-MM-DD) of an instant in Vietnam, regardless of the
 *  browser timezone. */
export const vnCalendarDate = (instant: Date | string) =>
    VN_DAY.format(new Date(instant))

const vnDayStart = (instant: Date) => Date.parse(`${vnCalendarDate(instant)}T00:00:00Z`)

/** Whole Vietnam calendar days since delivery; 0 on the delivery day. */
export function pendingAgeDays(deliveredAt: string, now = new Date()): number {
    const days = Math.round(
        (vnDayStart(now) - vnDayStart(new Date(deliveredAt))) / MS_PER_DAY,
    )
    return Math.max(0, days)
}

export type PendingAgeTone = 'muted' | 'warning' | 'danger'

/** At most 1 day is calm, 2-3 days needs attention, beyond 3 is overdue. */
export function pendingAgeTone(days: number): PendingAgeTone {
    if (days <= 1) return 'muted'
    return days <= 3 ? 'warning' : 'danger'
}

export function pendingAgeLabel(days: number): string {
    return days === 0
        ? m.einvoice_pending_age_today()
        : m.einvoice_pending_age({ days: String(days) })
}

export const PENDING_AGE_TONE_CLASS: Record<PendingAgeTone, string> = {
    muted: 'text-muted-foreground',
    warning: 'text-amber-700 dark:text-amber-300',
    danger: 'font-medium text-red-700 dark:text-red-300',
}
